module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newReturnMater"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart"
  }, [_c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "inline": true,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "退料类型:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择退料类型"
    },
    model: {
      value: (_vm.returnForm.returnType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "returnType", $$v)
      },
      expression: "returnForm.returnType"
    }
  }, _vm._l((_vm.pickingTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.returnForm.returnType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "残值类型:",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择残值类型"
    },
    on: {
      "change": _vm.selectResidualType
    },
    model: {
      value: (_vm.returnForm.residualType),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "residualType", $$v)
      },
      expression: "returnForm.residualType"
    }
  }, _vm._l((_vm.residualTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    }, [_vm._v(_vm._s(item.paraName))])
  }), 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr"
  }, [(_vm.returnForm.returnType == 1) ? _c('usualNewReturn', {
    attrs: {
      "returnForm": _vm.returnForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.returnForm.returnType == 2) ? _c('residualNewReturn', {
    attrs: {
      "returnForm": _vm.returnForm
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-45ba63dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/newReturnMater.vue
// module id = 1644
// module chunks = 0